// D24 D — botão "Comentário interno" no cabeçalho da linha do tempo → modal com textarea → interação Manual na linha do tempo, sem
// recarregar a tela. Spec docs/ticket-detail-2027/02-design/d24-v01.md §3.D + delta d24-v02.md §5/§6 + d24-v03.md (o mais novo prevalece);
// contrato 04-php/contrato-d24.md §3 (E-NOTA); parecer-d24-php-v01 F-1 (etapa `permissao` = `desligado`) e F-5 (corpo JSON, mesmo nonce).
//
// - A rota SEMPRE cria (o payload é montado no servidor, sem id): nada aqui identifica registro existente. O `nonce` identifica o RASCUNHO
//   (não um registro): gerado na 1ª abertura, guardado com o texto e reenviado igual em toda nova tentativa; o servidor responde
//   `repetido` (já gravou) ou `em_andamento` (1º POST ainda no ar). Um sucesso apaga o rascunho.
// - Rascunho por oportunidade, em memória: Cancelar/Esc/erro guardam {texto, nonce} no willClose; reabrir traz o texto de volta.
// - Swal 11.10.5 (LICOES 66): foco/disabled decididos pela resposta vão num setTimeout(…, 0); o preConfirm devolve o literal false para
//   ficar aberto e NUNCA rejeita. showValidationMessage é HTML (LICOES 31): só texto fixo (data-textos ou `message` fixo do servidor).
// - 2º gesto (LICOES 71/72): nos 600 ms depois de abrir, clique/tecla REAL nos botões é engolido por ouvintes de captura do willOpen.
// - Sucesso: #tk-tl-status, timeline recarregada em "Tudo" (GET da data-ajax do invólucro, sem grupo), #item_{id}[data-novo] por 6 s, foco
//   no NOVO .tk-tl-nota. Recarga falhou ou veio degradada (R-F1) → parcial (tk_nota_ok_sem_linha no status e numa linha por 6 s). Fechar depois de erro sem
//   confirmação (comunicacao/em_andamento/rede) também recarrega em "Tudo", para o atendente conferir antes de reenviar.
// - d24-v04 + d24-v05: no posErro, (b)/GET falho → aviso .tk-tl-lista-erro + "Recarregar linha do tempo" (aria-disabled, teto de 30 s,
//   descarte). Único anunciador = #tk-tl-status. recarregarTudo resolve 'trocou' | 'falhou' | 'descartado' (guarda ANTES do innerHTML).
//   Todo desfecho assíncrono atualiza a coluna sempre; o foco só com podeFocar(alvo) e o anúncio só sem modal (LinhaTempoFoco.js).
//   O trabalho depois do modal começa no didClose (o .then do Swal 11 roda durante os 150 ms da saída, com o aria-hidden no lugar).

const Foco = require('./LinhaTempoFoco');

const TEMPO_MS = 30000;
const JANELA_MS = 600;
const NOVO_MS = 6000;
const FECHA_MS = 2000;   // reserva do didClose (a saída do Swal dura 150 ms)
const MAX = 2000;
const ETAPAS_CANCELAR = ['oportunidade', 'desligado', 'permissao'];   // F-1: permissao como desligado

const NotaInterna = function () {

    const rascunhos = new Map();   // opp → { texto, nonce }
    const Sw = () => window.Swal;

    const csrf = () => {
        const m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : (typeof CSRF_TOKEN !== 'undefined' ? CSRF_TOKEN : '');
    };
    const fmt = (s, p) => String(s).replace(/:([a-z]+)/g, (m, k) => (p && k in p ? String(p[k]) : m));
    const inteiro = (v) => { const s = String(v == null ? '' : v).trim(); return /^[1-9][0-9]*$/.test(s) ? parseInt(s, 10) : 0; };

    // /^[A-Za-z0-9-]{16,64}\z/ no servidor. randomUUID = 36 caracteres hex + hífens.
    const novoNonce = () => {
        const c = window.crypto;
        if (c && typeof c.randomUUID === 'function') return c.randomUUID();
        if (c && typeof c.getRandomValues === 'function') {
            return Array.from(c.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
        }
        let s = '';
        while (s.length < 32) s += Math.random().toString(36).slice(2);
        return s.slice(0, 32);
    };

    // ---------- linha do tempo ----------
    const alvoTimeline = () => document.getElementById('ticket-detail-timeline');
    const status = (txt) => { const s = document.getElementById('tk-tl-status'); if (s) { s.textContent = ''; s.textContent = txt; } };
    // d24-v05 §1.2: com um Swal na tela, o anúncio é DESCARTADO (não adiado); o #tk-tl-status fica com o texto que já tinha.
    const anunciar = (txt) => { if (!Foco.modalNaTela()) status(txt); };

    // GET da URL do invólucro (openTimeline sem grupo = "Tudo"), com teto de TEMPO_MS (d24-v04 §3.2; S7: vale para os 3 chamadores).
    // d24-v05 §1.3: resolve 'trocou' | 'falhou' | 'descartado', nunca rejeita.
    // - 'descartado': no instante em que a resposta assenta (QUALQUER caminho: ok, (a), (b), !r.ok, catch, teto), o alvo saiu do DOM
    //   (troca de ticket) ou o `valido()` do chamador falhou (um chip/outra recarga trocou a coluna no voo). Conferido ANTES do innerHTML (O2).
    // - 'trocou': ok e, com `aceitarErro`, o (a) `timelineErro`. 'falhou': (b) literal sem cabeçalho, rede, !r.ok, não-JSON, d.error, teto.
    // R-F1 (parecer-d24-front-v01): sem `aceitarErro`, o (a) também não troca (a coluna fica com o botão e o chamador cai no parcial).
    const htmlUtil = (html, aceitarErro) => {
        const tpl = document.createElement('template');
        tpl.innerHTML = html;
        return !!tpl.content.querySelector('.tk-tl-cab') && (!!aceitarErro || !tpl.content.querySelector('[data-tl-erro]'));
    };
    const recarregarTudo = (alvo, aceitarErro, valido) => {
        const vale = () => !!alvo && alvo.isConnected && (!valido || !!valido());
        const inv = alvo ? alvo.closest('[data-ajax]') : null;
        const url = inv ? inv.dataset.ajax : '';
        if (!url) return Promise.resolve(vale() ? 'falhou' : 'descartado');
        const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        let relogio = null;
        // O teto não depende do fetch respeitar o signal: a corrida resolve 'falhou' (ou 'descartado') no prazo de qualquer jeito.
        const teto = new Promise((ok) => { relogio = setTimeout(() => { if (ctrl) ctrl.abort(); ok(null); }, TEMPO_MS); });
        let req;
        try {
            req = fetch(url, {
                method: 'GET', credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined,
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            }).then(r => (r.ok && (r.headers.get('content-type') || '').indexOf('json') >= 0 ? r.json() : null));
        } catch (e) {
            req = Promise.resolve(null);
        }
        return Promise.race([req, teto])
            .then((d) => {
                if (!vale()) return 'descartado';
                const res = d && typeof d === 'object' && !d.error ? d.result : null;
                if (!res || typeof res.html !== 'string' || !htmlUtil(res.html, aceitarErro)) return 'falhou';
                alvo.innerHTML = res.html;
                return 'trocou';
            })
            .catch(() => (vale() ? 'falhou' : 'descartado'))
            .then((v) => { clearTimeout(relogio); return v; });
    };

    // d24-v04 §5: foco de reserva no TÍTULO "Linha do tempo" (tabindex=-1 só se não tiver, removido no blur); sem título, a coluna.
    const focarReserva = (alvo) => {
        const t = alvo.querySelector('.tk-tl-cab .tk-tl-tit') || alvo;
        if (!t.hasAttribute('tabindex')) {
            t.setAttribute('tabindex', '-1');
            t.addEventListener('blur', () => { t.removeAttribute('tabindex'); }, { once: true });
        }
        t.focus({ preventScroll: true });
    };
    // Foco depois de uma recarga: o .tk-tl-nota (novo, ou o que ficou), senão o título. Só com podeFocar (d24-v05 §1.2).
    const focarDepois = (alvo) => {
        if (!alvo || !alvo.isConnected || !Foco.podeFocar(alvo)) return;
        const b = alvo.querySelector('.tk-tl-nota');
        if (b) b.focus({ preventScroll: true });
        else focarReserva(alvo);
    };
    // Desfecho 'trocou' com aceitarErro: anuncia o (a) pelo texto VISÍVEL do [data-tl-erro], ou tk_nota_lista_ok.
    const trocouAnuncio = (alvo, c) => {
        const e = alvo.querySelector('[data-tl-erro]');
        return e ? e.textContent.trim() : c.t('lista_ok');
    };

    // Item novo visível dentro da coluna (.tk-ctx-in), sem rolar a página: só se estiver fora da vista.
    const mostrarItem = (item) => {
        const col = item.closest('.tk-ctx-in');
        if (!col) return;
        const c = col.getBoundingClientRect(), r = item.getBoundingClientRect();
        if (r.top < c.top) col.scrollTop -= (c.top - r.top);
        else if (r.bottom > c.bottom) col.scrollTop += (r.bottom - c.bottom);
    };

    // ---------- aviso "a lista não atualizou" (d24-v04 §2/§3) ----------
    // Textos do aviso: os `c` de quem o criou (closure guardada aqui); sem eles, o data-textos do .tk-tl-nota da coluna.
    const avisoTextos = new WeakMap();   // .tk-tl-lista-erro → c
    const avisoGeracao = new WeakMap();  // .tk-tl-lista-erro → nº; um posErro que reaproveita o aviso invalida o Recarregar no ar
    const textosDaColuna = (alvo) => {
        const b = alvo ? alvo.querySelector('.tk-tl-nota') : null;
        let t = {};
        try { t = JSON.parse((b && b.dataset.textos) || '{}') || {}; } catch (e) { t = {}; }
        return { t: (k) => (t[k] || k) };
    };
    const avisoDe = (alvo) => {
        for (const el of alvo.children) if (el.classList.contains('tk-tl-lista-erro')) return el;
        return null;
    };
    // Cria (ou reaproveita: nunca 2) o aviso como irmão seguinte da .tk-tl-cab (sem ela, 1º filho). Texto por textContent. Sem role/aria-live.
    const avisoNaColuna = (alvo, c) => {
        let av = avisoDe(alvo);
        if (!av) {
            av = document.createElement('div');
            av.className = 'tk-tl-lista-erro';
            const p = document.createElement('p');
            p.className = 'tk-tl-lista-erro-txt';
            p.appendChild(document.createElement('span'));
            const rec = document.createElement('button');
            rec.type = 'button';
            rec.className = 'tk-tl-recarregar';
            av.append(p, rec);
            const cab = alvo.querySelector(':scope > .tk-tl-cab');
            if (cab) cab.after(av); else alvo.prepend(av);
        }
        avisoTextos.set(av, c);
        return av;
    };
    // Estado do aviso: texto, aria-* fora (sempre, com ou sem modal). Anúncio e foco seguem a regra única.
    const avisoEstado = (alvo, av, c, chave) => {
        const txt = c.t(chave);
        av.querySelector('.tk-tl-lista-erro-txt > span').textContent = txt;
        const rec = av.querySelector('.tk-tl-recarregar');
        rec.textContent = c.t('lista_recarregar');
        rec.removeAttribute('aria-disabled');
        av.removeAttribute('aria-busy');
        anunciar(txt);
        if (Foco.podeFocar(alvo)) rec.focus({ preventScroll: true });
    };
    // posErro (b)/GET falho: aviso com tk_nota_lista_erro, à vista (mostrarItem), foco no Recarregar.
    const avisoErro = (alvo, c) => {
        const av = avisoNaColuna(alvo, c);
        avisoGeracao.set(av, (avisoGeracao.get(av) || 0) + 1);
        avisoEstado(alvo, av, c, 'lista_erro');
        mostrarItem(av);
    };
    // Recarregar (clique/Enter/Espaço; aria-disabled = ignorado). Teto e descarte no recarregarTudo.
    const recarregar = (rec) => {
        const av = rec.closest('.tk-tl-lista-erro');
        const alvo = av ? av.closest('#ticket-detail-timeline') : null;
        if (!alvo) return;
        const c = avisoTextos.get(av) || textosDaColuna(alvo);
        const ger = avisoGeracao.get(av) || 0;
        rec.setAttribute('aria-disabled', 'true');
        av.setAttribute('aria-busy', 'true');
        recarregarTudo(alvo, true, () => av.isConnected && (avisoGeracao.get(av) || 0) === ger).then((res) => {
            if (res === 'descartado') return;
            if (res === 'trocou') { anunciar(trocouAnuncio(alvo, c)); focarDepois(alvo); return; }
            avisoEstado(alvo, av, c, 'lista_erro_persiste');   // (b)/falha/teto: o aviso fica; "fica" no Recarregar = volta, se pode
        });
    };

    // Sucesso (no didClose do modal). d24-v05 §1.3: guarda = a .tk-tl-cab do início (um chip no voo descarta a resposta).
    const sucesso = (c, j) => {
        const r = (j && j.result) || {};
        const id = inteiro(r.interaction_id);
        anunciar(c.t('ok'));
        const alvo = alvoTimeline();
        if (!alvo) return;
        const cab0 = alvo.querySelector(':scope > .tk-tl-cab');
        recarregarTudo(alvo, false, cab0 ? () => cab0.isConnected : null).then((res) => {
            if (res === 'descartado') return;
            if (res === 'trocou') {
                const item = id ? document.getElementById('item_' + id) : null;
                if (item && alvo.contains(item)) {
                    item.setAttribute('data-novo', '');
                    setTimeout(() => { item.removeAttribute('data-novo'); }, NOVO_MS);
                    mostrarItem(item);
                }
                focarDepois(alvo);
                return;
            }
            // Parcial (d24-v04 §4): salvou, a linha do tempo não atualizou. Linha de 6 s SEM role (anunciador único = #tk-tl-status),
            // depois do aviso persistente se houver, senão depois da .tk-tl-cab.
            anunciar(c.t('ok_sem_linha'));
            const ref = avisoDe(alvo) || alvo.querySelector(':scope > .tk-tl-cab');
            if (ref) {
                const p = document.createElement('p');
                p.className = 'tk-ev-meta tk-tl-nota-aviso';
                p.textContent = c.t('ok_sem_linha');
                ref.after(p);
                setTimeout(() => { p.remove(); }, NOVO_MS);
            }
            focarDepois(alvo);
        });
    };

    // posErro (no didClose do modal; d24-v04 §1 + d24-v05 §1.5). ok/(a) → troca + anúncio + foco no botão/título; (b)/falha → aviso.
    const posErroRecarga = (c, btn) => {
        const alvo = alvoTimeline();
        if (!alvo) { if (btn.isConnected) btn.focus({ preventScroll: true }); return; }
        const cab0 = alvo.querySelector(':scope > .tk-tl-cab');
        recarregarTudo(alvo, true, cab0 ? () => cab0.isConnected : null).then((res) => {
            if (res === 'descartado') return;
            if (res === 'trocou') { anunciar(trocouAnuncio(alvo, c)); focarDepois(alvo); return; }
            avisoErro(alvo, c);
        });
    };

    // Fechamento sem erro (S11): o botão que abriu, senão o .tk-tl-nota da coluna atual, senão o título. É o foco do próprio modal que
    // fechou (estava no popup), por isso não passa pelo focoLivre.
    const focarFechamento = (btn) => {
        if (btn.isConnected) { btn.focus({ preventScroll: true }); return; }
        const alvo = alvoTimeline();
        if (!alvo) return;
        const b = alvo.querySelector('.tk-tl-nota');
        if (b) b.focus({ preventScroll: true });
        else focarReserva(alvo);
    };

    // ---------- modal ----------
    const conteudo = (c, texto) => {
        const d = document.createElement('div');
        d.className = 'tk-nota-corpo';
        const l = document.createElement('label');
        l.className = 'tk-nota-label';
        l.setAttribute('for', 'tk-nota-txt');
        l.textContent = c.t('label');
        const ta = document.createElement('textarea');
        ta.id = 'tk-nota-txt';
        ta.className = 'tk-nota-txt';
        ta.maxLength = MAX;
        ta.rows = 5;
        ta.placeholder = c.t('placeholder');
        ta.setAttribute('aria-describedby', 'tk-nota-ajuda');
        ta.value = texto || '';
        const pe = document.createElement('div');
        pe.className = 'tk-nota-pe';
        const ajuda = document.createElement('span');
        ajuda.id = 'tk-nota-ajuda';
        ajuda.textContent = c.t('ajuda');
        const cont = document.createElement('span');
        cont.className = 'tk-nota-cont';
        cont.setAttribute('aria-live', 'off');
        const contar = () => { cont.textContent = fmt(c.t('contador'), { n: ta.value.length }); };
        contar();
        ta.addEventListener('input', contar);
        // Ctrl+Enter / ⌘+Enter salva (clique por código: passa pela janela). Enter sozinho quebra a linha.
        ta.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && !e.repeat) { e.preventDefault(); Sw().clickConfirm(); }
        });
        pe.append(ajuda, cont);
        d.append(l, ta, pe);
        return d;
    };

    const abrir = (btn) => {
        const Swal = Sw();
        if (!Swal || typeof Swal.fire !== 'function' || Swal.isVisible()) return;
        let textos = {};
        try { textos = JSON.parse(btn.dataset.textos || '{}') || {}; } catch (e) { textos = {}; }
        const c = {
            t: (k) => (textos[k] || k),
            url: btn.dataset.url,
            opp: inteiro(btn.dataset.opp),
            // ticket aberto NO CLIQUE (faixa do detalhe), só inteiro ≥ 1; sem ele, o campo não vai (ausente ≠ vazio).
            ticket: (() => { const f = document.querySelector('.tk-faixa[data-ticket]'); return f ? inteiro(f.dataset.ticket) : 0; })(),
        };
        if (!c.url || !c.opp) return;
        const rasc = rascunhos.get(c.opp) || { texto: '', nonce: novoNonce() };
        rascunhos.set(c.opp, rasc);
        const abertoEm = performance.now();
        const naJanela = () => performance.now() - abertoEm < JANELA_MS;
        let salvou = false;
        let posErro = false;

        const ta = () => { const h = Swal.getHtmlContainer(); return h ? h.querySelector('#tk-nota-txt') : null; };
        const agendar = (foco) => {
            setTimeout(() => {
                if (!Swal.isVisible() || Swal.isLoading()) return;
                const x = foco === 'cancelar' ? Swal.getCancelButton() : (foco === 'primario' ? Swal.getConfirmButton() : ta());
                if (x && !x.disabled) x.focus();
            }, 0);
        };
        const falhar = (msg, foco, marcaPosErro) => {
            const x = ta();
            if (x) x.readOnly = false;   // editável de novo em qualquer erro
            if (marcaPosErro) posErro = true;
            Swal.showValidationMessage(msg);
            agendar(foco);
            return false;
        };

        // d24-v05 §1.4: o trabalho depois do modal roda 1 vez, no didClose. Reserva de FECHA_MS só se o didClose nunca vier
        // (animationend perdido); nesse caso a regra única (modalNaTela/podeFocar) ainda vale dentro do trabalho.
        let fechou = () => {};
        const fechado = new Promise((ok) => { fechou = ok; });
        const depoisDeFechar = (fn) => {
            let feito = false;
            const vai = () => { if (!feito) { feito = true; fn(); } };
            fechado.then(vai);
            setTimeout(vai, FECHA_MS);
        };

        btn.setAttribute('aria-disabled', 'true');

        Swal.fire({
            title: c.t('titulo'),
            html: conteudo(c, rasc.texto),
            customClass: { popup: 'tk-nota-pop' },
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: c.t('salvar'),
            cancelButtonText: c.t('cancelar'),
            focusConfirm: false,
            returnFocus: false,   // o foco é decidido depois do didClose (botão; ou o NOVO botão depois da recarga)
            allowOutsideClick: () => { const x = ta(); return !Swal.isLoading() && !naJanela() && !!x && x.value === ''; },
            allowEscapeKey: () => !Swal.isLoading(),
            showLoaderOnConfirm: true,
            // LICOES 71: ouvintes do 2º gesto no willOpen (síncrono), de CAPTURA no popup (molde FaixaFinalizar).
            willOpen: (p) => {
                const popup = p || Swal.getPopup();
                const naAcao = (e) => (e.target instanceof Element ? e.target.closest('.swal2-actions button') : null);
                popup.addEventListener('click', (e) => {
                    const b = naAcao(e);
                    if (!b) return;
                    if (e.isTrusted && naJanela()) { e.preventDefault(); e.stopPropagation(); return; }
                    // Slot do anel = largura do primário no clique (antes do Swal escondê-lo).
                    if (b.classList.contains('swal2-confirm')) popup.style.setProperty('--tk-nota-prim-w', b.getBoundingClientRect().width + 'px');
                }, true);
                popup.addEventListener('keydown', (e) => {
                    if (e.repeat && e.key === 'Enter' && naAcao(e)) { e.preventDefault(); e.stopPropagation(); }
                }, true);
            },
            didOpen: () => {
                const vm = Swal.getValidationMessage();
                if (vm) vm.setAttribute('aria-live', 'assertive');
                const x = ta();
                if (x) { x.focus(); const n = x.value.length; x.setSelectionRange(n, n); }
            },
            // Cadeia de promessas, sem async/await (como o resto do 2027). NUNCA rejeita.
            preConfirm: () => {
                const x = ta();
                const texto = x ? x.value : '';
                if (texto.trim() === '') return falhar(c.t('erro_vazio'), 'textarea', false);   // sem requisição
                if (x) x.readOnly = true;
                const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
                const relogio = ctrl ? setTimeout(() => ctrl.abort(), TEMPO_MS) : null;
                const fim = () => { if (relogio) clearTimeout(relogio); };
                const corpo = { opportunity_id: c.opp, feedback: texto, nonce: rasc.nonce };
                if (c.ticket) corpo.ticket_id = c.ticket;
                let req;
                try {
                    req = fetch(c.url, {
                        method: 'POST', credentials: 'same-origin', body: JSON.stringify(corpo),
                        headers: {
                            'Content-Type': 'application/json', 'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': csrf(),
                        },
                        signal: ctrl ? ctrl.signal : undefined,
                    });
                } catch (e) {
                    fim();
                    return falhar(c.t('erro_rede'), 'cancelar', true);
                }
                return req.then((r) => {
                    if (r.status === 419 || r.redirected) return falhar(c.t('erro_sessao'), 'cancelar', false);
                    if (!r.ok) return falhar(c.t('erro_rede'), 'cancelar', true);
                    if ((r.headers.get('content-type') || '').indexOf('json') < 0) return falhar(c.t('erro_sessao'), 'cancelar', false);
                    return r.json().then((j) => {
                        if (!j || typeof j !== 'object') return falhar(c.t('erro_sessao'), 'cancelar', false);
                        if (!j.error) { salvou = true; return j; }   // ok (repetido ou não): fecha
                        // result.etapa é o canônico (contrato-d24 §3.3); message é sempre texto fixo do idioma.
                        const etapa = (j.result && typeof j.result.etapa === 'string') ? j.result.etapa : '';
                        const msg = typeof j.message === 'string' && j.message !== '' ? j.message : null;
                        if (etapa === 'validacao') return falhar(msg || c.t('erro_validacao'), 'textarea', false);
                        if (ETAPAS_CANCELAR.indexOf(etapa) >= 0) {
                            return falhar(msg || c.t(etapa === 'oportunidade' ? 'erro_oportunidade' : 'erro_desligado'), 'cancelar', false);
                        }
                        if (etapa === 'em_andamento') return falhar(msg || c.t('erro_andamento'), 'cancelar', true);
                        // comunicacao (ou etapa desconhecida, tratada igual): sem confirmação de gravação → conferir antes de reenviar.
                        return falhar(msg || c.t('erro_rede'), 'cancelar', true);
                    });
                }).catch(() => falhar(c.t('erro_rede'), 'cancelar', true))   // rede, AbortError (30 s), JSON inválido
                  .then((v) => { fim(); return v; }, () => { fim(); return false; });
            },
            // K2 da D15: o rascunho é guardado no willClose (com o texto que está na tela), nunca antes.
            willClose: () => {
                if (salvou) { rascunhos.delete(c.opp); return; }
                const x = ta();
                rascunhos.set(c.opp, { texto: x ? x.value : rasc.texto, nonce: rasc.nonce });
            },
            didClose: () => { fechou(); },   // d24-v05 §1.4
        }).then((res) => {
            if (btn.isConnected) btn.removeAttribute('aria-disabled');
            // d24-v05 §1.4: o .then só DECIDE; a execução começa no didClose (fim da saída, aria-hidden já fora).
            const ok = !!(res && res.isConfirmed && salvou);
            const pe = posErro;
            depoisDeFechar(() => {
                if (ok) sucesso(c, res.value);
                else if (pe) posErroRecarga(c, btn);   // d24-v04 §1: ok/(a) troca e anuncia; (b)/falha → aviso + Recarregar
                else focarFechamento(btn);             // S11
            });
        }).catch(() => {
            if (btn.isConnected) btn.removeAttribute('aria-disabled');
        });
    };

    return {
        init: function () {
            document.addEventListener('click', (e) => {
                const btn = e.target instanceof Element ? e.target.closest('#ticket-detail-timeline .tk-tl-nota') : null;
                if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
                e.preventDefault();
                abrir(btn);
            });
            // d24-v04 §3: "Recarregar linha do tempo" do aviso. Não é .bt-ajax (LICOES 56); aria-disabled = no ar → ignorado.
            document.addEventListener('click', (e) => {
                const rec = e.target instanceof Element ? e.target.closest('#ticket-detail-timeline .tk-tl-lista-erro .tk-tl-recarregar') : null;
                if (!rec || rec.getAttribute('aria-disabled') === 'true') return;
                e.preventDefault();
                recarregar(rec);
            });
        },
    };
}();

module.exports = NotaInterna;
